module.exports = __webpack_public_path__ + "img/littl_girls4.53c9a8f7.jpg";